var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayGreyFillLarge = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.6,
    height: 20,
    viewBox: "0 0 25.6 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "display-fill",
    d: "M9.6,18a5.56,5.56,0,0,1-.4,2.4H8A.8.8,0,0,0,8,22h9.6a.8.8,0,0,0,0-1.6H16.4A5.56,5.56,0,0,1,16,18h6.4a3.134,3.134,0,0,0,3.2-3.2V5.2A3.134,3.134,0,0,0,22.4,2H3.2A3.134,3.134,0,0,0,0,5.2v9.6A3.134,3.134,0,0,0,3.2,18Z",
    transform: "translate(0 -2)",
    fill: "#cdd4d9"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayGreyFillLarge);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNS42IiBoZWlnaHQ9IjIwIiB2aWV3Qm94PSIwIDAgMjUuNiAyMCI+CiAgPHBhdGggaWQ9ImRpc3BsYXktZmlsbCIgZD0iTTkuNiwxOGE1LjU2LDUuNTYsMCwwLDEtLjQsMi40SDhBLjguOCwwLDAsMCw4LDIyaDkuNmEuOC44LDAsMCwwLDAtMS42SDE2LjRBNS41Niw1LjU2LDAsMCwxLDE2LDE4aDYuNGEzLjEzNCwzLjEzNCwwLDAsMCwzLjItMy4yVjUuMkEzLjEzNCwzLjEzNCwwLDAsMCwyMi40LDJIMy4yQTMuMTM0LDMuMTM0LDAsMCwwLDAsNS4ydjkuNkEzLjEzNCwzLjEzNCwwLDAsMCwzLjIsMThaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC0yKSIgZmlsbD0iI2NkZDRkOSIvPgo8L3N2Zz4K";